import axios, {
  AxiosError,
  AxiosInstance,
  InternalAxiosRequestConfig,
} from "axios";
import { LoginResponse, triggerLogout } from "./authService";

// Base API configuration
const api: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL, // Backend API URL
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

let refreshTries = 0;
export let accessToken: string | null = null;

export const setAccessToken = (token: string | null) => {
  accessToken = token;
};

// Request interceptor
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// // Response interceptor - simple version without refresh
//
// api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
//   if (accessToken) {
//     config.headers["Authorization"] = `Bearer ${accessToken}`;
//   }
//   return config;
// });

// Response interceptor
api.interceptors.response.use(
  (res) => {
    refreshTries = 0; // reset khi thành công
    return res;
  },
  async (error: AxiosError) => {
    const original = error.config as InternalAxiosRequestConfig & {
      _retry?: boolean;
    };

    if (error.response?.status === 401 && !original._retry) {
      if (refreshTries >= 3) {
        // 👉 Chuyển về login
        // Flicker UI when use window.location.href = "/login";
        triggerLogout();
        return Promise.reject(error);
      }

      original._retry = true;
      refreshTries++;

      try {
        const res = await api.post("/auth/refresh-token");
        const { accessToken } = res.data as LoginResponse;
        setAccessToken(accessToken);

        original.headers["Authorization"] = `Bearer ${accessToken}`;
        return api(original); // retry
      } catch (err) {
        return Promise.reject(err);
      }
    }
    if (error.response?.status === 403 && original.url !== "/auth/login") {
      // 👉 Chỉ chuyển về trang không có quyền truy cập sau khi login
      window.location.href = "/403";
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default api;
